"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { getEnv } from "./utilities";
import DatalayerPageView from "./DatalayerPageView";
const DatalayerClickManager = dynamic(() => import("./DatalayerClickManager"), {
  ssr: false
});
interface DatalayerProps {
  slug: string;
  siteName: string;
  locale: string;
}
export const Datalayer = t0 => {
  const $ = _c(3);
  const {
    locale
  } = t0;
  let hostname = "";
  if (typeof window !== "undefined") {
    hostname = window?.location?.hostname || "";
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getEnv(hostname);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const environment = t1;
  let t2;
  if ($[1] !== locale) {
    t2 = <div className="datalayer-gtm hide hidden"><DatalayerPageView hostname={hostname} locale={locale} environment={environment} /><DatalayerClickManager locale={locale} /></div>;
    $[1] = locale;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};